<div class="col-sm-2 pass-on-log-filter">
    <div class="pass-on-log-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="pass-on-log-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="currentCheckbox" #currentCheckbox (change)="changeFilter()">
                <label for="currentCheckbox"><svg-checked></svg-checked></label>
                <span>Current</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="futureCheckbox" #futureCheckbox (change)="changeFilter()">
                <label for="futureCheckbox"><svg-checked></svg-checked></label>
                <span>Future</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pastCheckbox" #pastCheckbox (change)="changeFilter()">
                <label for="pastCheckbox"><svg-checked></svg-checked></label>
                <span>Past</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="readCheckbox" #readCheckbox (change)="changeFilter()">
                <label for="readCheckbox"><svg-checked></svg-checked></label>
                <span>Read</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="unreadCheckbox" #unreadCheckbox (change)="changeFilter()">
                <label for="unreadCheckbox"><svg-checked></svg-checked></label>
                <span>Unread</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/pass-on-log-filter/pass-on-log-filter.component.html